import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { stateMap } from '@digital-platform/rs-addresses/domain';
import { Facility } from '@digital-platform/rs-cms/domain';
import { CtaButtonComponent } from '@digital-platform/rs-cms/feature-ptypes';

@Component({
  selector: 'digital-platform-facility-item',
  templateUrl: './facility-item.component.html',
  styleUrls: ['./facility-item.component.scss'],
  imports: [CommonModule, CtaButtonComponent],
  standalone: true,
})
export class FacilityItemComponent {
  public urlCache: { [key: string]: string } = {};
  @Input() location: Facility | null = null;
  @Input() i = 0;

  constructor(private router: Router) {}

  navigateToFacilityDetails() {
    if (this.location) {
      const { state, facility_name } = this.location;
      this.router.navigate([
        `/facilities/${this.setStateName(state)}/${this.setFacilityName(
          facility_name
        )}`,
      ]);
    }
  }

  public setFacilityName(facilityName: string): string {
    return this.urlStructure(facilityName);
  }

  public setStateName(state: string): string {
    const stateKey = stateMap[state.trim()];
    return stateKey ? this.urlStructure(stateKey) : '';
  }

  private urlStructure(name: string): string {
    if (this.urlCache[name]) {
      return this.urlCache[name];
    }

    const url = name
      .replace(/\./g, '')
      .replace(/\s/g, '-')
      .replace(/--+/g, '-')
      .toLowerCase();

    this.urlCache[name] = url;
    return url;
  }
}
